import { Component, OnInit, Input } from '@angular/core';
import { PropertyListingService } from '../../../../providers/property-listing.service';
import { CommonService } from '../../../../providers/common.service';
import { ValidationService } from '../../../../providers/validation.service';
import { ActivatedRoute, Params } from '@angular/router';
import { NewsTickerDetailsModel } from '../../../../models/NewsTickerDetailsModel';
import * as Highcharts from 'highcharts/highstock';
import { LoaderService } from '../../../../providers/loader.service';
declare var require: any;
if (typeof Highcharts === 'object') {
  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
@Component({
    selector: 'app-summary-tab',
    templateUrl: './summary-tab.component.html',
    styleUrls: ['./summary-tab.component.css']
})
export class SummaryTabComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, private Loader: LoaderService, private commonService: CommonService, public Validation: ValidationService, protected activatedRoute: ActivatedRoute) { }
  chart: any;
  quote: any;
  ticker: string = "";
  summaryDetail = {} as any;
  @Input() isChart = false;
  ohlc = [];
  chartHolder = "chart";
  volume = [];
  groupingUnits: any;
  calendarEvents = {} as any;
  newsDetail = {} as NewsTickerDetailsModel;
  @Input() summaryData = {} as any;
  @Input() tickerSymbol = "";
  @Input() tenant = "";
  selectedRange = 2;
  timeOffset = 0;
  ngOnInit() {
    this.Loader.display(true);
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["ticker"] != null) {
        this.ticker = params["ticker"];
      }
      else {
        this.ticker = this.tickerSymbol;
      }
    });
    this.commonService.GetNewsTickerDetails(this.ticker, 6100).subscribe(response => {
      if (!response.IsLatestAvailable) {
        this.getData(true, this.ticker, "1d", "1mo");
      }
      else {
        var data = JSON.parse(response.DataJson);
        if (data != null && data.timestamp) {
          this.chart = data;
          this.quote = this.chart.indicators.quote[0];
          this.ohlc = [];
          this.volume = [];
          let dataLength = this.chart.timestamp.length;
          let i = 0;

          for (i; i < dataLength; i += 1) {
            this.ohlc.push([
              this.Validation.convertDateTimeToUTCStamp(new Date((this.chart.timestamp[i] - this.timeOffset) * 1000)), // the date
              Number(Number(this.quote.open[i]).toFixed(2)), // open
              Number(Number(this.quote.high[i]).toFixed(2)), // high
              Number(Number(this.quote.low[i]).toFixed(2)), // low
              Number(Number(this.quote.close[i]).toFixed(2)) // close
            ]);

            this.volume.push([
              this.Validation.convertDateTimeToUTCStamp(new Date((this.chart.timestamp[i] - this.timeOffset) * 1000)), // the date
              this.quote.volume[i] // the volume
            ]);
          }
        this.loadMore();
        }
      }

      this.Loader.display(false);
    });

    if (this.summaryData != null) {
      this.summaryDetail = this.summaryData.summaryDetail;
      this.calendarEvents = this.summaryData.calendarEvents;
    }
  };

  getData(isInitialLoad: boolean = false, tickerName, interval, period) {
    this.propertyListing.GetTickerChart(tickerName, interval, period).subscribe(response => {
      if (response["chart"].result != null && response["chart"].result[0].timestamp) {
        this.chart = response["chart"].result[0];
        this.timeOffset = this.chart["meta"]["gmtoffset"];
        if (isInitialLoad) {
          this.newsDetail.DataJson = JSON.stringify(response["chart"].result[0]);
          this.newsDetail.Ticker = this.ticker;
          this.newsDetail.TypeId = 6100;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
        this.quote = this.chart.indicators.quote[0];
        this.ohlc = [];
        this.volume = [];
        let dataLength = this.chart.timestamp.length;
        let i = 0;

        for (i; i < dataLength; i += 1) {

          this.ohlc.push([
            this.Validation.convertUTCDateToLocalDate(new Date(this.chart.timestamp[i] * 1000)).getTime(), // the date
            Number(Number(this.quote.open[i]).toFixed(2)), // open
            Number(Number(this.quote.high[i]).toFixed(2)), // high
            Number(Number(this.quote.low[i]).toFixed(2)), // low
            Number(Number(this.quote.close[i]).toFixed(2)) // close
          ]);

          this.volume.push([
            this.Validation.convertUTCDateToLocalDate(new Date(this.chart.timestamp[i] * 1000)).getTime(), // the date
            this.quote.volume[i] // the volume
          ]);
        }
        this.loadMore();
      }

    });
  }
  that = this;
  afterSetExtremes(interval, type, selected) {
    this.selectedRange = selected;
    var identifier = this.isChart ? '#chartLarge' : '#chart'
    var chart1 = $(identifier).highcharts();
    chart1["showLoading"]();
    this.that.getData(false, this.that.ticker, interval, type);
  }
  loadMore() {
    var identifier = this.isChart ? '#chartLarge' : '#chart';
    var chart1 = $(identifier).highcharts();
    if (chart1 != undefined) {
      $(identifier).highcharts()["destroy"]();
    }
    // split the data set into ohlc and volume           
    let that = this;
    // create the chart
    Highcharts.stockChart({
      chart: {
        renderTo: that.isChart ? 'chartLarge' : 'chart',
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%b-%d-%Y',
          minute: '%I:%M %p',
          hour: '%I %p'
        },
        labels:
        {
          rotation: -40,
        },
        //minRange: 3600 // one hour
      },
      rangeSelector: {
        buttons: [{
          type: 'day',
          count: 1,
          text: '1d',
          events: {
            click: function () {
              that.afterSetExtremes("15m", "1d", 0);
            }
          }
        }, {
          type: 'day',
          count: 5,
          text: '5d',
          events: {
            click: function () {
              that.afterSetExtremes("1d", "5d", 1);
            }
          }
        }, {
          type: 'month',
          count: 1,
          text: '1m',
          events: {
            click: function () {
              that.afterSetExtremes("1d", "1mo", 2);
            }
          }
        },
        {
          type: 'month',
          count: 6,
          text: '6m',
          events: {
            click: function () {
              that.afterSetExtremes("1d", "6mo", 3);
            }
          }
        }, {
          type: 'year',
          count: 1,
          text: '1y',
          events: {
            click: function () {
              that.afterSetExtremes("1d", "1y", 4);
            }
          }
        },

        {
          type: 'all',
          text: 'All',

          events: {
            click: function () {
              that.afterSetExtremes("1d", "max", 5);
            }

          }
        }
        ],
        inputEnabled: false, // it supports only days
        allButtonsEnabled: true,
        selected: that.selectedRange
      },

      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      yAxis: [{
        labels: {
          align: 'right',
          x: -3
        },
        title: {
          text: ''
        },
        height: '60%',
        lineWidth: 2,
        resize: {
          enabled: true
        }
      }, {
        labels: {
          align: 'right',
          x: -3
        },
        title: {
          text: 'Volume'
        },
        top: '65%',
        height: '35%',
        offset: 0,
        lineWidth: 2
      }],

      tooltip: {
        split: true,
        dateTimeLabelFormats: {
          minute: '%b-%d-%Y %I:%M %p'
        }

      },

      series: [{
        type: 'ohlc',
        name: '',
        data: this.ohlc,
        color: 'black',
      }, {
        type: 'column',
        name: 'Volume',
        data: this.volume,
        color: 'rgb(149,206,255)',
        yAxis: 1,
      }]
    });
  }
}
